module.exports = __webpack_public_path__ + "static/media/gears.05f59379.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gears.svg
// module id = 2711
// module chunks = 1